import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import QuestionScreen from '../components/QuestionScreen/QuestionScreen';
import Map from '../components/Map/Map';

const Question = ({ inactivity }) => {

    // define variables
    const { locale, location } = useParams();
    
    // change language
    const { i18n } = useTranslation();

    // trigger tracking
    useEffect(() => {

        // set language
        i18n.changeLanguage(locale);

        gtag('event', 'page_view', {
            page_path: `/${locale}/question`
        });

        // set inactivity functionality
        inactivity();

    }, []);

    // render html
    return(
        <>
            <QuestionScreen language={locale} location={location} />
            <Map type="blur" />
        </>
    );
}

export default Question;